import { EnrichmentPlugin, Event } from '@amplitude/analytics-types';
import { getPageTitleByPath } from '../../../routes-config';

export const PAGE_VIEWED_EVENT_NAME = 'page_viewed';

/**
 * @description all SPA pages by default are tracked as one page with [ArtHelper] title.
 * This plugin allows to change the title so specific spa page is tracked separately */
export const changePageTitlesPlugin: EnrichmentPlugin = {
  name: 'change-page-titles-plugin',
  type: 'enrichment',
  execute: async (event: Event): Promise<Event | null> => {
    if (event.event_properties && event.event_type === PAGE_VIEWED_EVENT_NAME) {
      const currentPath: string = event.event_properties['[Amplitude] Page Path'];

      const newPageTitle = '[ArtHelper] ' + getPageTitleByPath(String(currentPath));

      event.event_properties['[Amplitude] Page Title'] = newPageTitle;
    }

    return event;
  },
};

export const changeClickEventNamePlugin: EnrichmentPlugin = {
  name: 'change-click-event-name-plugin',
  type: 'enrichment',
  execute: async (event: Event): Promise<Event | null> => {
    if (event.event_type === '[Amplitude] Element Clicked') {
      event.event_type = 'element_clicked';
    }

    return event;
  },
};
